import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { OAuthService, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { AppSettingsService, IEnvironmentSettings } from '../app-settings/app-settings.service';
import { authConfig } from './auth-config';
import { AuthGuardWithForcedLogin } from './auth-guard-with-forced-login.service';
import { AuthGuard } from './auth-guard.service';
import { authModuleConfig } from './auth-module-config';
import { AuthService } from './auth.service';

// We need a factory since localStorage is not available at AOT build time
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function storageFactory(): OAuthStorage {
  return localStorage;
}

@NgModule({ imports: [OAuthModule.forRoot(authModuleConfig)], providers: [
        AuthService,
        AuthGuard,
        AuthGuardWithForcedLogin,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [AppSettingsService, OAuthService],
          //Get the configuration from AppSettings for the OAuthService
          //To provide conectivity with IDM
          useFactory: (appSettings: AppSettingsService, oauthService: OAuthService) => {
            return () => {
              return appSettings.getEnvironmentVariablesToPromise().then((env: IEnvironmentSettings) => {
                //Configuration values for OAuthService
                authModuleConfig.resourceServer.allowedUrls = [env.apiUrl];
                authConfig.issuer = env.authentication.issuer;
                authConfig.clientId = env.authentication.clientId;
                authConfig.scope = env.authentication.scope;
                //Set the configuration for OAuthService
                oauthService.configure(authConfig);
              });
            };
          }
        },
        { provide: OAuthStorage, useFactory: storageFactory },
        AppSettingsService
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    if (parentModule) {
      throw new Error('AuthModule is already loaded. Import it in the AppModule only');
    }
  }
}
